import styles from "@styles/pages/oraculo/database-customer-card.module.css";
import { Currency } from "@utils/Currency";
import { Numbers } from "@utils/Numbers";
import { Phone } from "@utils/Phone";

export const CustomerCard = ({ customer, onClick }) => {
  return (
    <div className={styles.customer}>
      <div
        className={styles.header}
        onClick={() => onClick && onClick(customer)}
      >
        <div className={styles.phone} title={Phone.format(customer.phone)}>
          <i className={`far fa-${getIcon(customer)}`} />
          <p>{Phone.format(customer.phone)}</p>
        </div>
        <i className="fal fa-chevron-right" />
      </div>
      <div className={styles.content}>
        <div className={styles.item}>
          <div>
            <p>Nome</p>
            <span>{customer.name || "Nome não registrado!"}</span>
          </div>
          <div>
            <span
              className={`${
                styles["progress-completeness"]
              } ${getClassCompleteness(customer)}`}
            >
              {Math.trunc(calculateCompleteness(customer))}%
            </span>
          </div>
        </div>
        <div className={styles.item}>
          <div>
            <p>Total gasto</p>
            <span>{Currency.formatCurrency(+customer.total_orders || 0)}</span>
          </div>
          <div>
            <p>Conversões</p>
            <span>{Numbers.formatInt(customer.count_orders)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const getIcon = (customer) => {
  switch (customer) {
    case customer.phone: {
      return "phone";
    }
    case customer.doc: {
      return "address-card";
    }
    case customer.email: {
      return "envelope-open";
    }
    default: {
      return "phone";
    }
  }
};

const isArrayEmpty = (value) => {
  return Array.isArray(value) && value.length == 0;
};

const calculateCompleteness = (data) => {
  const values = [];
  const controllers = ["phone", "name", "email", "birthdate", "has_address"];
  controllers.map((item) => {
    if (
      data[item] !== undefined &&
      !isArrayEmpty(data[item]) &&
      data[item] !== null &&
      data[item] != "" &&
      data[item] != "0000-00-00"
    )
      values.push(data[item]);
  });

  return (values.length * 100) / 5;
};

const getClassCompleteness = (data) => {
  const value = calculateCompleteness(data);

  if (value < 30) {
    return styles.red;
  }

  if (value < 80) {
    return styles.yellow;
  }

  return styles.green;
};
